<div>
    <div class="page-wrapper">
        <app-header></app-header>
        <div class="page-body-wrapper">
            <div class="page-sidebar" [class.open]="navServices.collapseSidebar">
                <app-sidebar></app-sidebar>
            </div>
            <div class="page-body">
                <app-breadcrumb></app-breadcrumb>
                <main [@animateRoute]="o.isActivated ? (o.activatedRoute?.routeConfig?.path || '') : ''" [@.disabled]="disableAnims">
                    <router-outlet #o="outlet"></router-outlet>
                </main>
                <!-- <router-outlet></router-outlet> -->
            </div>
            <footer class="footer">
                <app-footer></app-footer>
            </footer>
        </div>
    </div>
    <!-- Widget global de subida -->
    <app-upload-widget></app-upload-widget>
    <!-- RTL toggle oculto — no requerido en la UI de Learnify -->
    <!-- <div class="btn-light custom-theme" [class.rtl]="layoutClass" (click)="clickRtl(layoutType)">{{layoutType}}</div> -->
</div>